// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table td.shrunk[data-v-d1c68d9c],table th.shrunk[data-v-d1c68d9c]{width:1px;white-space:nowrap}table td.nowrap[data-v-d1c68d9c],table th.nowrap[data-v-d1c68d9c]{white-space:nowrap}[data-v-d1c68d9c] table th.shrunk,td.shrunk[data-v-d1c68d9c]{width:1px;white-space:nowrap}[data-v-d1c68d9c] table th.nowrap,td.nowrap[data-v-d1c68d9c]{white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
